import {
    Divider,
    Grid,
    TextField,
    Container,
    Dialog,
    DialogTitle,
    IconButton,
    Card,
    CardContent
} from '@mui/material'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'


function ProfilePasswordDrawer({
    visible,
    title,
    onSubmit,
    onClose,
    okText,

}) {

    const initialValues = {
        CurrentPassword: '',
        NewPassword: '',
        confirmPassword: '',
    }

    const handleSubmit = async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onSubmit(values)
    }

    const validationSchema = Yup.object().shape({
        CurrentPassword: Yup.string()
            .min(6, 'Must be at least 6 characters')
            .max(255)
            .required('Required'),
        NewPassword: Yup.string()
            .min(6, 'Must be at least 6 characters')
            .max(255)
            .required('Required'),
        confirmPassword: Yup.string().when('NewPassword', {
            is: (val) => !!(val && val.length > 0),
            then: Yup.string()
                .required('Required')
                .oneOf([Yup.ref('NewPassword')], 'Passwords do not match'),
        }),
    })

    return (
        <>
            <Dialog
                maxWidth='xs'
                fullWidth
                open={visible}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            status,
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider my={1} />
                                <Card>
                                    <CardContent>
                                        <Grid container spacing={6}>
                                            <Grid item md={12}>
                                                <TextField
                                                    size="small"
                                                    name="CurrentPassword"
                                                    label="Current Password"
                                                    value={values.CurrentPassword}
                                                    error={Boolean(touched.CurrentPassword && errors.CurrentPassword)}
                                                    fullWidth
                                                    helperText={touched.CurrentPassword && errors.CurrentPassword}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="password"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={6}>
                                            <Grid item md={12}>
                                                <TextField
                                                    size="small"
                                                    name="NewPassword"
                                                    label="New Password"
                                                    value={values.NewPassword}
                                                    error={Boolean(touched.NewPassword && errors.NewPassword)}
                                                    fullWidth
                                                    helperText={touched.NewPassword && errors.NewPassword}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="password"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={6}>
                                            <Grid item md={12}>
                                                <TextField
                                                    size="small"
                                                    name="confirmPassword"
                                                    label="Confirm Password"
                                                    value={values.confirmPassword}
                                                    error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                                                    fullWidth
                                                    helperText={touched.confirmPassword && errors.confirmPassword}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    type="password"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item >
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </>
    );
}

export default ProfilePasswordDrawer;